<template lang="pug">
header.header-page-global.flex.items-center.justify-between.pb-4
    .header-page-global__meta
        h1.heading {{ HeaderGlobalHeading }}
        
    .header-page-global__cta
        ul.breadcrumb.flex.items-center.justify-between
            li(v-if="HeaderGlobalBreadcrumb === undefined || HeaderGlobalBreadcrumb.length === 0")
                span Home
            template(v-else)
                li
                    router-link(to="/") Home
                li(v-for="(breadcrumb,index) in HeaderGlobalBreadcrumb" :key="index")
                    span(v-if="(index + 1) === HeaderGlobalBreadcrumb.length") {{ breadcrumb.name }}
                    router-link(v-else :to="breadcrumb.url") {{ breadcrumb.name }}

</template>

<script>
export default {
    name: 'HeaderGlobal',
    props: {
        HeaderGlobalHeading: String,
        HeaderGlobalBreadcrumb: Array,
    },
    mounted() {
        // console.log('mounted in breadcrumb')
        // console.log(this.HeaderGlobalBreadcrumb)
    }
}
</script>

<style lang="sass">
.breadcrumb
    a, span
    font-size: 13px

    a
        display: block
        padding: 0.5rem
        position: relative
        &:hover
            color: #2E9C46
        &:after
            content: '/'
            margin-left: 0.5rem
            opacity: 0.3
            color: #3d3d3d
    span
        opacity: 0.5

</style>

